<template>
    <section class="innerpages animate__animated animate__slideInRight">
       <div class="container ">
          <div class="row">
             <div class="col-md-12">
                <div class="filterTabs">
                   <div class="tab-content">
                      <div class="card">
                        <b-table
                          :items="masterData"
                          :fields="fields"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                          sort-icon-right
                          responsive="sm"
                          show-empty
                          @row-clicked="openDetails"
                          tbody-tr-class="dataDivider"
                          >
                          <template v-slot:empty="scope">
                            <h5 class="noData">No Data</h5>
                          </template>
                          <template v-slot:cell(total)="data">
                            <i style="font-style:normal">{{ data.value }} 
                              <span class="icon-arrow">
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve">
                                  <polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 "></polygon>
                                </svg>
                            </span>
                            </i>
                          </template>
                        </b-table>
                         </div>
                   </div>
                </div>
             </div>
          </div>
       </div>
    </section>
  </template>
  <script>
  export default {
   data(){
     return {
       firstReload: true,
       sortBy: 'total',
       sortDesc: true,
       fields: [
          { key: 'name', label: "Name", sortable: true, 'class': 'headingClassQualification'},
          { key: 'total', label: "Count", sortable: true }],
       masterData: []
     }
   },
   created(){
     this.loadTabData();
     this.$store.dispatch('setActiveTitle', "Backlog Report");
     this.tabDefaults.searchFn = this.loadTabData;
   },
   watch: {
    $route(to, from) {
      this.loadTabData();
    },
  },
   methods: {
     openDetails(backlog){
       let activeItem = {label: backlog.name, labelNo:2, itemType: "backlog", itemId: backlog.user_id, data: backlog.data}
       this.$store.dispatch('setActiveItem', activeItem);
       this.$router.push({
        name: "StatusDetails",
        query: this.$route.query
      });
     },
     loadTabData(){
      const query = this.$route.query;
      let managerIds = ''
      let substatus = ''
      let exeusers = ''
      let status = ''
      let executive = ''
      let enquiry = ''
      let todays_call = ''
      let sourceIds = ''
      if (this.firstReload) {
        managerIds = this.$store.getters.multiManger.join(',') || query.manager_ids;
        exeusers = this.$store.getters.exeusers.join(',') || query.user_ids;
        status = this.$store.getters.status.join(',') || query.lead_statuses;
        substatus = this.$store.getters.substatus.join(',') || query.lead_sub_statuses;
        executive = this.$store.getters.executive || query.executive_type;     
        enquiry = this.$store.getters.enquiry || query.enquiry;     
        todays_call = this.$store.getters.todays_call || query.todays_call;     
        sourceIds = this.$store.getters.selectedSources.join(',') || query.source_ids;     

      } else {
        managerIds = this.$store.getters.multiManger.join(',');
        exeusers = this.$store.getters.exeusers.join(',');
        status = this.$store.getters.status.join(',');
        substatus = this.$store.getters.substatus.join(',');
        executive = this.$store.getters.executive || ''
        enquiry = this.$store.getters.enquiry || ''
        todays_call = this.$store.getters.todays_call || ''
        sourceIds = this.$store.getters.selectedSources.join(',');

      }
       let queryParams = {
          manager_ids: managerIds,
          user_ids: exeusers,
          lead_statuses: status,
          lead_sub_statuses: substatus,
          executive_type: executive,
          enquiry: enquiry,
          todays_call: todays_call,
          source_ids: sourceIds
        };
        Object.keys(queryParams).forEach(key => {
          if (!queryParams[key]) delete queryParams[key];
        });
        if (JSON.stringify(this.$route.query) !== JSON.stringify(queryParams)) {
          this.$router.push({ path: this.$route.path, query: queryParams });
        }
      let searchParams = new URLSearchParams(queryParams).toString();
       let url = `/back_log?${searchParams}`
       this.$axios.get(url)
         .then(res => {
           if(res){
             this.masterData = res.data;
             this.firstReload = false
           }
         })
         .catch((err) => {
          if (err.response.status === 500) {
            swal({
              title: "Server Error!",
              icon: "error",
            });
          } else {
            swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error",
            });
          }
        });
     }
   },
   computed: {
     sSources(){
        return this.$store.getters.selectedSources;
      },
     defaultStartDate(){
       return this.$moment().subtract(this.activeTabHash.start,'d')
     },
     defaultEndDate(){
       return this.$moment().subtract(this.activeTabHash.end,'d')
     },
     activeTab(){
       return this.tabDefaults.tab;
     },
     tabDefaults(){
       return this.$store.getters.sDefaults;
     }
   }
  }
  </script>
                              
                            
  
                          
  
  